<template>
	<ppe-form 
		entityName="B2"
		formkey="b2_eu"
		title="B2. Sources de dangers" 
		title-field="{company.name}"
 	  sub-title=""

		:schema="schema" 
		:endpoint="endpoint"
		:redirect="'/ppe_eu/home/:operationid'" 
		>

	</ppe-form>
</template>
<script>
 
import Business from 'ppe-business'
import Utils    from '../ppe/utils'

export default {
	data() {
		console.log("this.$route.params.operationid", this.$route.params.operationid)
		return {
			//endpoint : "/eu/b2" + (this.$route.params.id?'?id='+this.$route.params.id:('?operationid='+this.$route.params.operationid+"&companyid="+this.$route.query.companyid)),
			endpoint : "/eu/b2?id="+this.$route.params.id+"&companyid="+this.$route.query.companyid,
			schema : [
				{ card:"Sources des dangers propres à l’Entreprise Utilisatrice (E.U.)", cardkey:"b2_card_sourceOfDangers",
					body:Business.sourceOfDangers,
				},

				{ card: "Unités de travail sur le site de l'opération", cardkey:"b2_card_working_units",
					body : [
						{
							type:'group', repeatable: true,
							name: 'workUnits',  label : 'Unités de travail',
							addLabel: 'Ajouter une unité de travail', validation : "min:0,length", size:'medium',
							children:[
									{ component: 'div', class:'display-inline', children:[
										{name:"name",   		   label:"Nom",           type: "text",     validation: 'required', class:'col-md-7'}, 
										{name:"description",   label:"Description",   type: "text",     validation: '', class:'col-md-5'},
									]}
							]
						},
					]
				},
				Utils.getGetManagerCard(),
				Utils.getAdminCard(),
				],

		}
	},

};
</script>
<style>
.display-inline {
	display:   flex;
	flex-wrap: wrap;
}

.formulate-input-element-checkboxtable .formulate-input-label {
	/*white-space:nowrap;*/
	min-width: 40%;
}
</style>
